export default __webpack_public_path__ + "static/media/checkIcon.42345855.svg";